import * as models from "../RiderDetails/RiderDetailsModelBundle";
import * as components from "../RiderDetails/RiderDetailsCompBundle";

export class ProductAndRiderDetailsService {
    private static instance: ProductAndRiderDetailsService;

    constructor() {
        // Initialization logic here
    }

    public static getInstance(): ProductAndRiderDetailsService {
        if (!ProductAndRiderDetailsService.instance) {
            ProductAndRiderDetailsService.instance = new ProductAndRiderDetailsService();
        }
        return ProductAndRiderDetailsService.instance;
    }

    public getProductAndRiderDetails(productInfoPortlets: components.ProductInfoPortlet[]): models.ProductAndRiderDetails[] {
        let productAndRiderDetails: models.ProductAndRiderDetails[] = [];

        for (let i = 0; i < productInfoPortlets.length; i++) {
            productAndRiderDetails.push(productInfoPortlets[i].getProductAndRiderDetails());
        }

        return productAndRiderDetails;
    }
}